module.exports = __webpack_public_path__ + "img/collections.bf2e9fc.png";